function testimonialsSlider(){
    jQuery('.testimonials-list').slick({
        dots : true,
        infinite : false,
        speed : 300,
        slidesToShow : 3,
        slidesToScroll : 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow : 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow : 1,
                }
            },
        ]
    });
}

function teamSlider(){
    jQuery('.team-slider').slick({
        dots : true,
        infinite : true,
        speed : 300,
        slidesToShow : 3,
        slidesToScroll : 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow : 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow : 1,
                    centerMode: false,
                    variableWidth: false,
                }
            },
        ]
    });
}

function gallerySlider(){
    jQuery('.gallery-block').slick({
        dots : false,
        infinite : true,
        speed : 300,
        slidesToShow : 3,
        slidesToScroll : 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: true,
        appendArrows: jQuery('.gallery-block-arrows'),
        responsive: [
            {
                breakpoint: 1921,
                settings: {
                    slidesToShow : 2,
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow : 1,
                }
            },
        ]
    });
}

function prices(){
    jQuery(".prices-item .h5").click(function(){
        jQuery(this).parent('.prices-item').toggleClass('active');
    });
}

function mobileMenu(){
    jQuery(".header-top .mobile-nav").click(function(){
        jQuery("body").toggleClass('mobile-menu-active');
    });
}
function menu(){
    function scrollToHash(hash) {
        if (hash) {
            const targetId = hash.replace(/^.*#/, '');
            const $target = jQuery('#' + targetId);

            if ($target.length) {
                jQuery('html, body').animate({
                    scrollTop: $target.offset().top
                }, 200, function () {
                    jQuery('.services-item').removeClass('active');
                    $target.addClass('active');
                });
            }
        }
    }

    // Click on menu links
    jQuery('.header-top .menu li.services li a, #secondary-menu-footer a').on('click', function () {
        const href = jQuery(this).attr('href');
        const hash = href.includes('#') ? href.substring(href.indexOf('#')) : '';
        scrollToHash(hash);
    });

    // On page load with hash
    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }
}

function ajaxForm() {
    jQuery('.ajax-form').on('submit', function(e) {
        e.preventDefault();

        if (jQuery('#form-response').length === 0) {
            jQuery(this).after('<div id="form-response"></div>');
        }

        var $form = jQuery(this);
        var lang = document.documentElement.lang.split('-')[0];

        jQuery.ajax({
            url: theme.ajax_url,
            type: 'POST',
            data: jQuery(this).serialize() + '&lang=' + encodeURIComponent(lang),
            success: function(response) {
                if(response.data.status == 'success'){
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "lead_visit",
                        name: $form.find('input[name="vardas"]').val(),
                        surname: $form.find('input[name="pavarde"]').val(),
                        email: $form.find('input[name="elpastas"]').val(),
                        phone: $form.find('input[name="telefonas"]').val()
                    });

                    if (response.data.redirect) {
                        location.href = response.data.redirect;
                    }

                    jQuery('#form-response').html('<p class="scs">' + response.data.message + '</p>');
                    jQuery('.ajax-form .button').prop('disabled', true);

                }else{
                    jQuery('#form-response').html('<p class="err">' + response.data.message + '</p>');
                }
            },
            error: function() {
                jQuery('#form-response').html('<p>Something went wrong.</p>');
            }
        });
    });
}

function slider(){
    const slider = jQuery('.slider-list').slick({
        dots : true,
        infinite : true,
        speed : 300,
        slidesToShow : 1,
        slidesToScroll : 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        //centerMode: true,
        appendDots: jQuery('.slider-list-arrows .dots'),
    });
    slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        jQuery('.slider-list-arrows .nav .active').html('0'+(currentSlide+1));
    });
}

jQuery(document).ready(function () {
    "use strict";

    testimonialsSlider();
    teamSlider();
    gallerySlider();
    prices();
    mobileMenu();
    menu();
    ajaxForm();
    slider();

});
